export const GEARBOX_ASSET_TYPE = 'gearbox';
